import axios from 'axios';
import router from '@/router'
import {Auth} from "./index";

axios.interceptors.request.use(function (config) {
    config.headers['Authorization'] = window.localStorage.getItem('token')
    if (window.localStorage.getItem('lang')) {
        config.headers['Accept-Language'] = window.localStorage.getItem('lang')
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    return response
}, error => {
    let errorResponse = error.response;
    if (errorResponse.status === 401) {
        // split token by space and get last item
        let tokenSplitted = window.localStorage.token.split(" ")
        tokenSplitted = tokenSplitted[tokenSplitted.length - 1]
        return Auth.tokenRefresh({
            'token': tokenSplitted
        }).then(response => {
            window.localStorage.setItem('token', 'JWT ' + response.data.token)
            return axios(errorResponse.config);
        }).catch(error => {
            window.localStorage.removeItem('token')
            router.push({name: 'Login'})
            return Promise.reject(error);
        });
    }
    return Promise.reject(error);
})

export default function (url) {
    const prepareURL = (urlParams) => {
        urlParams = urlParams || {}
        if (typeof urlParams !== 'object') {
            urlParams = {
                id: urlParams
            }
        }

        const convertURLFragment = fragment => fragment.startsWith(':') ? urlParams[fragment.slice(1)] : fragment
        return url.split('/').map(convertURLFragment).join('/').replace('//', '/')
    }

    return {
        fetch: (urlParams, payload) => {
            return axios.get(prepareURL(urlParams), payload)
        },
        update: (urlParams, payload) => {
            return axios.put(prepareURL(urlParams), payload)
        },
        get: (urlParams, payload) => {
            return axios.get(prepareURL(urlParams), payload)
        },
        save: (payload) => {
            return axios.post(prepareURL(), payload)
        },
        delete: (urlParams) => {
            return axios.delete(prepareURL(urlParams))
        }
    }
}



// WEBPACK FOOTER //
// ./src/api/service.js